<template>
  <a class="a-no-highlight" :href="libraryLink">
    <div class="library-item-link activity activity-with-button" :test-cms-page-id="pageId">
      <div class="library-link-content">
        <!-- Attach click to a child to prevent click through overlay -->
        <div class="activity-button-wrapper">
          <div
            class="activity-button"
            :style="{
              backgroundImage,
              backgroundSize: '60%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }"
          >
            <span class="activity-button-inner">
              <span></span>
            </span>
          </div>
        </div>
        <div class="activity-description">
          <slot></slot>
        </div>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { type DayOrPageType } from "../../services/cms/cms-type-definitions";

const props = defineProps<{
  activityId: string;
  pageId: string;
  pageUid: string;
  dayOrPageType?: DayOrPageType;
}>();

const backgroundImageFileName = computed(() => {
  if (props.dayOrPageType === "journal") {
    return "journal-pink.svg";
  }

  if (props.dayOrPageType === "library") {
    return "book-pink.svg";
  }

  return null;
});

const backgroundImage = computed(() => {
  return backgroundImageFileName.value
    ? `url(/content/images/develop/day-graphics/${backgroundImageFileName.value})`
    : "none";
});

const libraryLink = computed(() => {
  return `/resources/develop/${props.pageUid}`;
});
</script>

<style lang="less">
.library-item-link {
  cursor: pointer;

  .library-link-content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
  }

  .activity-button {
    width: 68px;
    height: 68px;
  }
}
</style>
